<app-instrument-run-info-panel
  [run]="selectedInstrumentRun"
  [isOpen]="isInfoPanelOpen"
  (closed)="onInfoPanelClosed()"
/>

<div class="sub-container">
  <div class="d-flex">
    <app-table-search (filterChanged)="onFilterChanged($event)"></app-table-search>

    <app-buttons
      style="margin-left: 15px"
      [isDisabled]="selectedInstrumentRunItems.length === 0"
      [name]="btnNameShare"
      [buttonType]="btnMatFlat"
      [buttonStyle]="
        selectedInstrumentRunItems.length === 0
          ? btnStyleFilledSmallForPrimaryBtnDisabled
          : btnStyleFilledSmallForPrimaryBtn
      "
      (buttonClickEvent)="onShareClicked()"
    >
    </app-buttons>
  </div>

  <app-buttons
    [isDisabled]="false"
    [name]="btnName"
    [buttonType]="btnMatStroked"
    [buttonStyle]="btnStyleStroked"
    (buttonClickEvent)="openFileUploadModal()"
  >
  </app-buttons>
</div>
<app-table
  [displayedColumnLabels]="displayedColumnLabels"
  [displayedColumns]="displayedColumns"
  [dataSource]="dataSource"
  [showCheckbox]="showCheckboxInTable"
  [showActionButtonsInPagination]="showActionBtnsInPagination"
  [showActionColumn]="true"
  [showMenuButton]="true"
  [showRunButton]="false"
  [showDownloadResultButton]="false"
  [showDeleteMenuButton]="false"
  [showEditMenuItem]="true"
  [firstColumnClickable]="true"
  [isRowActive]="isRowActiveFn"
  (firstColumnClicked)="onGetInfoClicked($event.data)"
  (rowMenuOpened)="onRowMenuOpened($event)"
  (rowMenuClosed)="onRowMenuClosed()"
  (onSampleEditButtonClicked)="onEditClicked($event)"
  (onGetInfoMenuButtonClicked)="onGetInfoClicked($event)"
  (onPaginationSecondaryBtnClicked)="openDeleteConfirmationModal()"
  (checkboxChanged)="handleCheckboxChange($event)"
  (onPaginationPrimaryBtnClicked)="onCreateNewSampleBtnClicked()"
>
</app-table>
